import Validation from '@core/logic/Validation'
import { BasicProductV2 as BasicProduct } from '@master/model/kyc-form/product/BasicProductV2'
import NeedsBase from '@master/model/kyc-form/need-analysis/NeedsBase'

export default class RcmdValidation extends Validation {
  validate (allProducts: BasicProduct[], needsBases1: NeedsBase[], needsBases2: NeedsBase[], hasClient2: boolean, belongsTo: string) {
    const { getMessages, ADD, ADDMANDATORY } = this.validator()
    this.belongsTo = belongsTo

    if (allProducts.length === 0) {
      ADD(() => 'At least one product must be recommended.', ['Product Recommendations'])
      return getMessages()
    }

    allProducts
      .forEach((product, index) => {
        ADDMANDATORY(() => {
          if (!product.clientChoice) {
            const productNamePrefix = 'Product ' + index
            const productNameInfo = product.productName ? productNamePrefix + ' ( ' + product.productName + ' )' : productNamePrefix
            return `Client's Decision: ${productNameInfo}'s Client Choice cannot be empty`
          }
        }, ['Client\'s Decision'])
      })

    let combinedNeeds = needsBases1
    if (hasClient2) combinedNeeds = [...needsBases1, ...needsBases2]
    const needs = combinedNeeds
      .filter(({ plan, level }) => plan && (level !== null && level !== undefined && level !== 'na' && level !== ''))
      .map(({ needs }) => needs)

    const uniqueNeeds = [...new Set(needs)]

    uniqueNeeds.forEach(need => {
      if (typeof need === 'undefined') {
        // need not found from map, no need to check
        return
      }

      ADD(() => {
        const metNeeds = allProducts
          .some(product => {
            const needsCovered = product.productNeedsCovered || []
            return needsCovered.includes(need)
          })

        if (!metNeeds) {
          return `Current products do not meet the ${need} needs of the client.`
        }
      }, ['Product Recommendations'])
    })

    return getMessages()
  }
}
